import { CourseNavigationItem, PlayerConfig, PlayerMode } from '../../../../services/course-player.service';

/**
 * Pure decision: should the consolidated header strip display the
 * "Override Active" chip?
 *
 * Only meaningful in instructor preview, when the current item is a module
 * with video-completion gating. Mirrors the `canOverrideVideoRequirement()`
 * role check from QuizPanelComponent.
 */
export interface OverrideChipInput {
  playerMode: PlayerMode;
  currentItem: CourseNavigationItem | null;
  playerConfig: PlayerConfig | null | undefined;
}

export function shouldShowOverrideChip(input: OverrideChipInput): boolean {
  if (input.playerMode !== 'instructor_preview') return false;
  const item = input.currentItem;
  if (!item || item.type !== 'module') return false;
  if (!item.hasVideo || (item.requiredWatchPercentage ?? 90) === 0) return false;
  if (!input.playerConfig?.enforceVideoCompletion) return false;
  return true;
}
